import { Check, Minus } from 'lucide-react';

const rows = [
  { feature: 'Email depolama', free: '5 GB', pro: '50 GB', biz: 'Limitsiz' },
  { feature: 'Email ünvanı', free: '1', pro: '5', biz: 'Limitsiz' },
  { feature: 'Xüsusi domen', free: false, pro: true, biz: true },
  { feature: 'IMAP/SMTP', free: true, pro: true, biz: true },
  { feature: 'Spam filtri', free: 'Əsas', pro: 'Qabaqcıl', biz: 'AI-əsaslı' },
  { feature: 'Şifrələmə', free: 'TLS', pro: 'AES-256', biz: 'AES-256+E2E' },
  { feature: 'Texniki dəstək', free: 'Email', pro: 'Prioritet', biz: '7/24 SLA' },
  { feature: 'SSO inteqrasiyası', free: false, pro: false, biz: true },
];

function Cell({ val }: { val: string | boolean }) {
  if (val === true) return <Check size={18} className="text-emerald-500 mx-auto" />;
  if (val === false) return <Minus size={18} className="text-slate-300 mx-auto" />;
  return <span className="text-sm text-slate-600">{val as string}</span>;
}

export default function FeatureTable() {
  const { t } = useTranslation();
  return (
    <div className="max-w-5xl mx-auto mt-24">
      <div className="text-center mb-10">
        <h2 className="font-display text-3xl font-bold text-slate-900 mb-2">{t('pricing.feature_table_title')}</h2>
        <p className="text-slate-500">{t('pricing.feature_table_subtitle')}</p>
      </div>
      <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
        <table className="w-full">
          <thead>
            <tr className="border-b border-slate-100">
              <th className="text-left p-4 text-sm font-semibold text-slate-500 w-1/2">Xüsusiyyət</th>
              <th className="p-4 text-center text-sm font-semibold text-slate-700">{t('pricing.plan1_name')}</th>
              <th className="p-4 text-center text-sm font-semibold text-primary-600 bg-primary-50/50">{t('pricing.plan2_name')}</th>
              <th className="p-4 text-center text-sm font-semibold text-slate-700">{t('pricing.plan3_name')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i} className={`border-b border-slate-50 ${i % 2 === 0 ? 'bg-slate-50/40' : 'bg-white'}`}>
                <td className="p-4 text-sm text-slate-700 font-medium">{row.feature}</td>
                <td className="p-4 text-center"><Cell val={row.free} /></td>
                <td className="p-4 text-center bg-primary-50/20"><Cell val={row.pro} /></td>
                <td className="p-4 text-center"><Cell val={row.biz} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
